import {
  DECREASE_STEP,
  GO_TO_STEP,
  INCREASE_STEP,
  LOAD_PRODUCTS_FAILURE,
  LOAD_PRODUCTS_INIT,
  LOAD_PRODUCTS_SUCCESS,
  POST_ORDER_FAILURE,
  POST_ORDER_PENDING,
  POST_ORDER_SUCCESS,
  RESET,
  SET_ADDRESS_ID,
  SET_SELECTED_IMAGE,
  SET_SELECTED_MACHINE,
  SET_SELECTED_SCREEN,
  TOGGLE_PRODUCT,
  SET_WORK_TYPE,
  WORK_TYPE_OFFICE,
  WORK_TYPE_PROFESSIONAL,
  HIDE_MONITOR_STEP_SPLASH,
  LOAD_ADDRESSES_SUCCESS,
  HIDE_ACCESORY_STEP_SPLASH,
  RESET_ALL_ACCESSORIES,
  HIDE_INITIAL_SPLASH,
  SHOW_INITIAL_SPLASH_MNGR,
} from './onboarding/onboardingActions'

import {
  STEP_MACHINE,
  STEP_SOFTWARE,
  STEP_ACCESSORIES_ALL,
  STEP_CONFIRM,
  STEP_SUMMARY,
  STEP_WORK_TYPE,
} from './onboarding/constants'

export const NAME_SPACE = 'ONBOARDING'

export const createProduct = props => {
  const {
    id,
    code,
    name,
    product_name: productName,
    specs,
    category_id: categoryId,
    asset_category_id: assetCategoryId,
    category_code: categoryCode,
    description,
    usage_description: usageDescription,
    img_url: imgUrl,
    group,
    price,
    stock,
    parent_products: parentProducts,
  } = props
  return {
    id,
    code,
    name,
    productName,
    specs,
    categoryId,
    workType: workTypeFromCategory(categoryId),
    assetCategoryId,
    categoryCode,
    description,
    usageDescription,
    imgUrl,
    group,
    price,
    stock,
    parentProducts: parentProducts && parentProducts.split(',').map(pid => Number(pid)),
  }
}

export const createAddress = ({ id, zip, city, address }) => ({
  id,
  zip,
  city,
  address,
})

const workTypeFromCategory = categoryId => {
  switch (categoryId) {
    case 12:
    case 13:
    case 23:
      return WORK_TYPE_PROFESSIONAL
    case 4:
    case 22:
      return WORK_TYPE_OFFICE
    default:
      return undefined
  }
}

export const initialState = {
  steps: [
    STEP_WORK_TYPE,
    STEP_MACHINE,
    STEP_SOFTWARE,
    STEP_ACCESSORIES_ALL,
    STEP_CONFIRM,
    STEP_SUMMARY,
  ],

  currentStep: 0,
  furthestStep: 0,
  workType: undefined,
  userType: undefined,
  addressId: undefined,
  displayMonitorStepSplash: true,
  displayAccessoryStepSplash: false,
  displayInitialSplash: true,
  displayInitialSplashMngr: false,

  productsIsLoading: false,
  productsIsLoaded: false,
  productsError: undefined,
  products: [],

  selectedMachineId: undefined,
  selectedImageId: undefined,
  selectedScreenId: undefined,
  doubleScreen: false,
  selectedProducts: [],
  postageProductId: undefined,

  orderIsLoading: false,
  orderIsLoaded: false,
  orderError: undefined,
  orderId: undefined,

  addresses: [],
}

function onboardingReducer(state = initialState, action) {
  const { currentStep, furthestStep, selectedProducts } = state
  const { pid, stepIncrease } = action
  switch (action.type) {
    case RESET:
      return {
        ...initialState,
        products: [...state.products],
        addresses: [...state.addresses],
      }
    case RESET_ALL_ACCESSORIES:
      return {
        ...state,
        selectedImageId: initialState.selectedImageId,
        selectedScreenId: initialState.selectedScreenId,
        doubleScreen: initialState.doubleScreen,
        selectedProducts: [],
      }
    case INCREASE_STEP:
      const newStep =
        currentStep < state.steps.length - stepIncrease ? currentStep + stepIncrease : currentStep
      return {
        ...state,
        currentStep: newStep,
        furthestStep: newStep > furthestStep ? newStep : furthestStep,
      }
    case DECREASE_STEP:
      return {
        ...state,
        currentStep: currentStep > 0 ? currentStep - 1 : 0,
      }
    case GO_TO_STEP:
      const goToStep = state.steps.indexOf(action.step)
      return {
        ...state,
        currentStep: goToStep,
        furthestStep: goToStep > furthestStep ? goToStep : furthestStep,
      }
    case TOGGLE_PRODUCT:
      return {
        ...state,
        selectedProducts: toggleProduct(state.products, selectedProducts, pid),
      }
    case SET_ADDRESS_ID:
      return {
        ...state,
        addressId: action.aid,
        postageProductId: action.pid,
      }
    case SET_WORK_TYPE:
      return {
        ...state,
        workType: action.workType,
        selectedMachineId: initialState.selectedMachineId,
        furthestStep: state.steps.indexOf(STEP_MACHINE),
      }
    case HIDE_MONITOR_STEP_SPLASH:
      return {
        ...state,
        displayMonitorStepSplash: false,
      }
    case HIDE_ACCESORY_STEP_SPLASH:
      return {
        ...state,
        displayAccessoryStepSplash: false,
      }
    case HIDE_INITIAL_SPLASH:
      return {
        ...state,
        displayInitialSplash: false,
      }
    case SHOW_INITIAL_SPLASH_MNGR:
      return {
        ...state,
        displayInitialSplashMngr: true,
      }
    case SET_SELECTED_SCREEN:
      return screen(state, action)
    case SET_SELECTED_MACHINE:
    case SET_SELECTED_IMAGE:
      return machine(state, action)
    case LOAD_PRODUCTS_INIT:
    case LOAD_PRODUCTS_FAILURE:
    case LOAD_PRODUCTS_SUCCESS:
      return products(state, action)
    case POST_ORDER_PENDING:
    case POST_ORDER_SUCCESS:
    case POST_ORDER_FAILURE:
      return order(state, action)
    case LOAD_ADDRESSES_SUCCESS:
      return addresses(state, action)
    default:
      return state
  }
}

function toggleProduct(products, selectedProducts, pid) {
  const product = products.find(product => product.id === pid)
  if ([/*10,*/ 9, 8, 20, 21].includes(product.categoryId)) {
    selectedProducts = selectedProducts.filter(spid => {
      const selectedProduct = products.find(product => product.id === spid)
      return selectedProduct.categoryId !== product.categoryId || selectedProduct.id === pid
    })
  }
  return selectedProducts.indexOf(pid) === -1
    ? [...selectedProducts, pid] // add
    : [...selectedProducts.filter(product => product !== pid)]
}

function machine(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_MACHINE:
      return {
        ...state,
        selectedMachineId: action.pid,
        selectedImageId: initialState.selectedImageId,
        currentStep: 1,
        furthestStep: 1,
      }
    case SET_SELECTED_IMAGE:
      return {
        ...state,
        selectedImageId: action.pid,
        // selectedProducts: action.pid ? [25319] : [], // add docking
      }
    default:
      return state
  }
}

function screen(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_SCREEN:
      const resetScreen =
        action.pid === state.selectedScreenId && action.double === state.doubleScreen
      return {
        ...state,
        selectedScreenId: resetScreen ? initialState.selectedScreenId : action.pid,
        doubleScreen: resetScreen ? initialState.doubleScreen : action.double,
      }
    default:
      return state
  }
}

function products(state = initialState, action) {
  switch (action.type) {
    case LOAD_PRODUCTS_INIT:
      return {
        ...state,
        productsIsLoading: true,
      }
    case LOAD_PRODUCTS_FAILURE:
      return {
        ...state,
        productsIsLoading: false,
        productsIsLoaded: true,
        productsError: action.error,
      }
    case LOAD_PRODUCTS_SUCCESS:
      const { products } = action
      return {
        ...state,
        productsIsLoading: false,
        productsIsLoaded: true,
        products: products.map(product => createProduct(product)),
        // selectedMachineId: 48,
        // selectedImageId: 11,
        // selectedScreenId: 36,
        // doubleScreen: true,
        // selectedProducts: [59, 53, 42, 65],
        // costObjectId: 7,
        // costObjectUser: 'Petter Nemeth',
      }
    default:
      return state
  }
}

function order(state = initialState, action) {
  switch (action.type) {
    case POST_ORDER_PENDING:
      return {
        ...state,
        orderIsLoading: true,
      }
    case POST_ORDER_FAILURE:
      return {
        ...state,
        orderIsLoading: false,
        orderIsLoaded: true,
        orderError: action.error,
      }
    case POST_ORDER_SUCCESS:
      return {
        ...state,
        orderIsLoading: false,
        orderIsLoaded: true,
        orderId: action.order.id,
      }
    default:
      return state
  }
}

function addresses(state = initialState, action) {
  switch (action.type) {
    case LOAD_ADDRESSES_SUCCESS:
      return {
        ...state,
        addresses: action.addresses.map(address => createAddress(address)),
      }
    default:
      return state
  }
}

export default onboardingReducer
